<template>
  <div>
    <header
      class="navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0 shadow"
    >
      <a class="navbar-brand col-md-3 col-lg-2 me-0 px-3" href="/"
        >Quotey Rating Management System</a
      >
      <button
        class="navbar-toggler position-absolute d-md-none collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#sidebarMenu"
        aria-controls="sidebarMenu"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="dropdown">
        <button
          class="btn btn-secondary bg-dark dropdown-toggle shadow-none border-0 w-100"
          type="button"
          id="dropdownMenuButton1"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {{ user.username }}
        </button>
        <ul
          class="dropdown-menu"
          aria-labelledby="dropdownMenuButton1"
          id="navDropdown"
        >
          <li><a class="dropdown-item" href="#">My Account</a></li>
          <li>
            <a class="dropdown-item" data-bs-toggle="modal" href="#exampleModal"
              >Log Out</a
            >
          </li>
        </ul>
      </div>

      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Logout</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              Are you sure you want to logout?
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                No
              </button>
              <button
                type="button"
                class="btn btn-primary"
                @click="logout"
                data-bs-dismiss="modal"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="container-fluid">
      <div class="row">
        <nav
          id="sidebarMenu"
          class="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse"
          style="overflow: auto;"
        >
          <div class="position-sticky pt-3">
            <h6
              class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-2 mb-1 text-muted"
            >
              <span>RATING ENGINE</span>
            </h6>
            <ul class="nav flex-column mb-2 px-4">
              <li class="nav-item">
                <a class="nav-link" href="/insurers">
                  <span data-feather="file-text"></span>
                  Insurers
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/calculators">
                  <span data-feather="file-text"></span>
                  Calculators
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#">
                  <span data-feather="file-text"></span>
                  Testing
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#">
                  <span data-feather="file-text"></span>
                  Logs
                </a>
              </li>
            </ul>
            <h6
              class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-3 mb-1 text-muted"
            >
              <span>MAPPING ENGINE</span>
            </h6>
            <ul class="nav flex-column mb-2 px-4">
              <li class="nav-item">
                <a class="nav-link" href="/sourcefields">
                  <span data-feather="file-text"></span>
                  Source Fields
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/map">
                  <span data-feather="file-text"></span>
                  Insurer Translation Map
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/lookup">
                  <span data-feather="file-text"></span>
                  Lookup Tables
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/rulesets">
                  <span data-feather="file-text"></span>
                  Rulesets
                </a>
              </li>

              <li class="nav-item">
                <a class="nav-link" href="/outboundfields">
                  <span data-feather="file-text"></span>
                  Outbound Fields
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/outboundrulesets">
                  <span data-feather="file-text"></span>
                  Outbound Rulesets
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#">
                  <span data-feather="file-text"></span>
                  Testing
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#">
                  <span data-feather="file-text"></span>
                  Logs
                </a>
              </li>
            </ul>
            <h6
              class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-3 mb-1 text-muted"
            >
              <span>ADMINISTRATION</span>
            </h6>
            <ul class="nav flex-column mb-2 px-4">
              <li class="nav-item">
                <a class="nav-link" href="/users">
                  <span data-feather="file-text"></span>
                  User Accounts
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#">
                  <span data-feather="file-text"></span>
                  Logs
                </a>
              </li>
            </ul>
          </div>
        </nav>
        <main class="col-md-9 ms-sm-auto col-lg-10 px-md-5" id="main">
          <div class="container"></div>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import config from "../config";
export default {
  data() {
    return { user: [] };
  },
  methods: {
    async logout() {
      const requestOptions = {
        method: "POST",
        credentials: "include",
      };
      const response = await fetch(config.baseURL + "/logout", requestOptions);
      const data = await response.json();
      console.log(data);
      if (data["Accepted"]) this.$router.push("/login");
    },
  },
  async mounted() {
    $("#nav").remove();
    const res = await fetch(config.baseURL + "/get_current_user", {
      credentials: "include",
    });
    const data = await res.json();
    console.log(data);
    this.user = data;
  },
};
</script>

<style scoped>
#logoutbtn {
  cursor: pointer;
}

.container {
  position: relative;
}
.container::before {
  content: "";
  background-image: url("https://quotey.io/wp-content/uploads/2020/10/robot.bmp");
  background-size: 30rem;
  background-repeat: no-repeat;
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  opacity: 40%;
  height: 730px;
  background-position: right center;
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-size: 30rem;
}
.bd-placeholder-img {
  font-size: 1.125rem;
  text-anchor: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

@media (min-width: 768px) {
  .bd-placeholder-img-lg {
    font-size: 3.5rem;
  }
}
body {
  font-size: 0.875rem;
}

.feather {
  width: 16px;
  height: 16px;
  vertical-align: text-bottom;
}

.sidebar {
  position: fixed;
  top: 0;
  bottom: 0;

  left: 0;
  z-index: 100;
  padding: 48px 0 0;
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, 0.1);
}

@media (max-width: 767.98px) {
  .sidebar {
    top: 2rem;
  }
}

.sidebar-sticky {
  position: relative;
  top: 0;
  height: calc(100vh - 48px);
  padding-top: 0.5rem;
  overflow-x: hidden;
  overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
}

.sidebar .nav-link {
  font-weight: 500;
  color: #333;
}

.sidebar .nav-link .feather {
  margin-right: 4px;
  color: #727272;
}

.sidebar .nav-link.active {
  color: #007bff;
}

.sidebar .nav-link:hover .feather,
.sidebar .nav-link.active .feather {
  color: inherit;
}

.sidebar-heading {
  font-size: 0.75rem;
  text-transform: uppercase;
}

/*
 * Navbar
 */

.navbar-brand {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 1rem;
}

.navbar .navbar-toggler {
  top: 0.25rem;
  right: 1rem;
}

.navbar .form-control {
  padding: 0.75rem 1rem;
  border-width: 0;
  border-radius: 0;
}

.form-control-dark {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.1);
}

.form-control-dark:focus {
  border-color: transparent;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.25);
}

.dropdown-menu {
  min-width: 8rem;
}
</style>
